import React from "react";
import styled, { css } from "styled-components";

const ButtonWrapper = styled.button(
  (props) => `
  padding: ${props.viewPadding || "0 20px"};
  width: ${props.width || "auto"};
  height: ${props.height || "40px"};
  font-size: ${props.fontSize || "13px"};
  font-weight: 600;
  margin: ${props.margin || "0"};
  color: ${props.labelColor || "#fff"};
  background-color: ${props.backgroundColor || "#003E85"};
  background: ${props.bgColor || props.bgColor};
  border: none;
  border-radius: ${props.borderRadius || "2px"};
  text-transform: uppercase;
  /*box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);*/
  box-shadow: ${props.boxShadow || "0 10px 10px rgba(0, 0, 0, 0.08)"};
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  &:focus {
    box-shadow: 0 0 0 2px #fff, 0 0 0 3px ${
      props.bgColor ? props.bgColor : "#003E85"
    };
    outline: none;
  }
  
  ${
    props.disabled &&
    `
      background-color: #dbdbdb !important;
      border: none;
      color: #b7aaaa;
      cursor: not-allowed;
    `
  };
`
);
const spin = css`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const Circle = styled.div`
  border: 3px solid white;
  border-top: 3px solid white;
  border-radius: 50%;
  margin: auto;
  width: 20px;
  height: 20px;
  animation: ${spin} 2s linear infinite;
`;

const Button = ({
  width,
  social,
  labelColor,
  backgroundColor,
  label,
  isLoading,
  borderRadius,
  bgColor,
  disabled,
  padding,
  fontSize,
  margin,

  ...props
}) => {
  return (
    <ButtonWrapper
      backgroundColor={backgroundColor}
      labelColor={labelColor}
      borderRadius={borderRadius}
      bgColor={bgColor}
      width={width}
      disabled={disabled}
      fontSize={fontSize}
      margin={margin}
      {...props}
    >
      {social ? (
        <React.Fragment>{label}</React.Fragment>
      ) : isLoading ? (
        <Circle />
      ) : (
        label
      )}
    </ButtonWrapper>
  );
};

export default Button;
